import { useGetRolePermissionsList } from 'api/accessControl/useGetRolePermissionsList/useGetRolePermissionsList';
import RolePermissionsSelectionModal from 'components/private/Modals/accessControl/RolePermissionsSelectionModal/RolePermissionsSelectionModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useRolePermissionsTableColumns from 'hooks/accessControl/useRolePermissionsTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

const RolePermissionsList = () => {
  const { roleGuid } = useParams();
  const { can } = usePermissions();

  const canEditPermissions = can(
    permissions.general.categories.keySettings.accessLevel.roles
      .permissionsEdit,
  );

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [selectedRows, setSelectedRows] = useState([]);

  const [activeModal, setActiveModal] = useState(null);

  const { getRolePermissionsList, loading, pageRef, rolePermissionsList } =
    useGetRolePermissionsList();
  const tableRef = useRef(null);

  const fetchPermissions = useCallback(() => {
    if (!roleGuid) return;
    getRolePermissionsList(
      { Guid: roleGuid, Page: page, Count: pageSize },
      () => {
        setPage(page);
      },
    );
  }, [getRolePermissionsList, roleGuid, pageSize]);

  useEffect(() => {
    if (!roleGuid) return;
    fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleGuid]);

  const closeModal = useCallback(() => setActiveModal(null), []);

  const [columnsData] = useRolePermissionsTableColumns({
    apiRef: tableRef,
  });

  function getPageData(pageNumber) {
    if (!roleGuid) return;
    setPage(pageNumber);
    getRolePermissionsList({
      Guid: roleGuid,
      Page: pageNumber,
      Count: pageSize,
    });
  }

  return (
    <>
      <div>{pageRef?.refTitle}</div>
      {loading ? (
        <PageSpinner loading />
      ) : (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={rolePermissionsList[page]}
          rows={rolePermissionsList[page]}
          pageSize={pageSize}
          isDeletable={false}
          isLoading={loading}
          addLable={canEditPermissions ? 'تغییر دسترسی' : undefined}
          onAddClick={
            canEditPermissions
              ? () => setActiveModal('editPermission')
              : undefined
          }
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          disableSelection
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          setSelectedRows={rows => setSelectedRows(rows)}
          selectedRows={selectedRows}
        />
      )}

      {canEditPermissions ? (
        <RolePermissionsSelectionModal
          roleGuid={roleGuid}
          onAssignPermissionSuccess={fetchPermissions}
          open={activeModal === 'editPermission'}
          handleClose={closeModal}
          getRolePermissionsListLoading={loading}
        />
      ) : null}
    </>
  );
};

export default RolePermissionsList;
